import { render, staticRenderFns } from "./DeleteChannelModal.vue?vue&type=template&id=827af956&scoped=true&"
import script from "./DeleteChannelModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteChannelModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteChannelModal.vue?vue&type=style&index=0&id=827af956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827af956",
  null
  
)

component.options.__file = "DeleteChannelModal.vue"
export default component.exports